import { FormField } from '@/components';
import type { CompanyFormData } from '../models';
import { FormSection } from '@/components/FormSection';

interface CompanyAddressSectionProps {
    formData: CompanyFormData;
    onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
}

export function CompanyAddressSection({ formData, onChange }: CompanyAddressSectionProps) {
    return (
        <FormSection icon="companyAddress" title="Firmenadresse">
            <div className="grid sm:grid-cols-2 gap-3 sm:gap-3">
                <FormField
                    labelKey="companyAdmin.form.street"
                    label="Strasse"
                    name="street"
                    type="text"
                    value={formData.street}
                    onChange={onChange}
                    className="sm:col-span-2"
                    required
                />

                {/* <FormField
        labelKey="companyAdmin.form.houseNumber"
        label="Hausnummer"
        name="houseNumber"
        type="text"
        value={formData.houseNumber}
        onChange={onChange}
        required
      />
      */}
                <FormField
                    labelKey="companyAdmin.form.addressLine2"
                    label="2. Adresszeile"
                    name="addressLine2"
                    type="text"
                    value={formData.addressLine2}
                    onChange={onChange}
                    className="sm:col-span-2"
                />

                <FormField
                    labelKey="companyAdmin.form.postalCode"
                    label="PLZ"
                    name="postalCode"
                    type="text"
                    value={formData.postalCode}
                    onChange={onChange}
                    required
                />

                <FormField
                    labelKey="companyAdmin.form.city"
                    label="Stadt"
                    name="city"
                    type="text"
                    value={formData.city}
                    onChange={onChange}
                    required
                />

                <FormField
                    labelKey="companyAdmin.form.phoneNumber"
                    label="Telefonnummer"
                    name="phoneNumber"
                    type="tel"
                    value={formData.phoneNumber}
                    onChange={onChange}
                />

                <FormField
                    labelKey="companyAdmin.form.email"
                    label="Email"
                    name="email"
                    type="email"
                    value={formData.email}
                    onChange={onChange}
                />
            </div>
        </FormSection>
    );
}
